module.exports = __webpack_public_path__ + "static/dogs-in-chicago-43b1e7cf92bb3473dd2367ddd5b0b55b.jpg";